import { api } from './client';

// Admin interventions: removing a fraudulent listing, and stepping into a
// pipeline. Each makes the move a company could make, through the same backend
// service, so history and notifications match -- attributed to the platform.

/** Archive a listing for good and close every open application on it. */
export function removeInternship(id, reason) {
  return api.post(`/admin/internships/${id}/remove`, { reason });
}

/** body: { status, note?, rejection_reason? } */
export function changeApplicationStatus(id, body) {
  return api.post(`/admin/recruitment/applications/${id}/status`, body);
}

export function cancelInterview(id, reason) {
  return api.post(`/admin/recruitment/interviews/${id}/cancel`, { reason });
}

export function withdrawOffer(id, reason) {
  return api.post(`/admin/recruitment/offers/${id}/withdraw`, { reason });
}
